const ManufacturerSvg = ({
  height = 22,
  width = 22,
  viewBox = '0 0 24 24',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      {/* Factory Shape */}
      <path d="M3 21V10l6 3V10l6 3V7l6 3v11H3z" />

      {/* Windows */}
      <path d="M7 21v-4" />
      <path d="M11 21v-4" />
      <path d="M15 21v-4" />

      {/* Roof Line */}
      <path d="M3 21h18" />
    </svg>
  );
};

export default ManufacturerSvg;
